import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EBMSuiteSharedRoutingModule } from './ebmsuite-shared-routing.module';
import { CustomersSearchComponent } from './components/customer-search/customers-search.component';
import { ItemsSearchComponent } from './components/items-search/items-search.component';
import { InvoiceDatepickerComponent } from './components/invoice-datepicker/invoice-datepicker.component';
import { ReceiptsCustomizeComponent } from './components/receipts-customize/receipts-customize.component';
import { ReceiptsPrintViewComponent } from './components/receipts-print-view/receipts-print-view.component';
import { TransactionTableComponent } from './components/transaction-table/transaction-table.component';
import { ButtonModule } from 'primeng/button';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NewsDetailsReusableComponent } from './components/news/news-details-reusable/news-details-reusable.component';
import { NewsListComponent } from './components/news/news-list/news-list.component';
import { FormlyModule } from '@ngx-formly/core';
import { TooltipTypeComponent } from 'src/app/common/formly/infoTooltipType';
import {
  PhoneNumberValidator,
  PhoneNumberValidatorMessage,
  EmailValidatorMessage,
  EmailValidator
} from 'src/app/common/formly/validations.formly';
import { CategoryAutocompleteFormlyField } from '../items/components/add-category/item-category-autocomplete.formly';
import { DialogModule } from 'primeng/dialog';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { SpeedDialModule } from 'primeng/speeddial';
import { PaginatorModule } from 'primeng/paginator';
import { BadgeModule } from 'primeng/badge';
import { ListboxModule } from 'primeng/listbox';
import { CalendarModule } from 'primeng/calendar';
import { ReceiptFooterComponent } from './components/receipt-footer/receipt-footer.component';
import { TransactionRecordAddComponent } from './components/transaction-record-add/transaction-record-add.component';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaymentIntegrationSetupComponent } from './components/payment-integration-setup/payment-integration-setup.component';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AvatarModule } from 'primeng/avatar';
import { ItemTaxesFormlyField } from './components/tax-setup/item-taxes.formly';
import { MultiSelectModule } from 'primeng/multiselect';
import { MemberSearchComponent } from './components/member-search/member-search.component';
import { CreateContactComponent } from 'src/app/common/modules/contacts/components/create-contact/create-contact.component';

@NgModule({
  declarations: [
    CustomersSearchComponent,
    ItemsSearchComponent,
    MemberSearchComponent,
    InvoiceDatepickerComponent,
    TransactionTableComponent,
    ReceiptsCustomizeComponent,
    ReceiptsPrintViewComponent,
    NewsDetailsReusableComponent,
    NewsListComponent,
    TransactionRecordAddComponent,
    PaymentIntegrationSetupComponent,
    ItemTaxesFormlyField
  ],
  imports: [
    CommonModule,
    EBMSuiteSharedRoutingModule,
    CreateContactComponent,
    ButtonModule,
    AutoCompleteModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule.forRoot({
      validators: [
        { name: 'phone', validation: PhoneNumberValidator },
        { name: 'email', validation: EmailValidator }
      ],
      validationMessages: [
        { name: 'phone', message: PhoneNumberValidatorMessage },
        { name: 'email', message: EmailValidatorMessage }
      ],
      types: [
        {
          name: 'tooltip',
          component: TooltipTypeComponent
        },
        {
          name: 'autoComplete',
          component: CategoryAutocompleteFormlyField
        },
        {
          name: 'selectItemTaxes',
          component: ItemTaxesFormlyField
        }
      ]
    }),
    InputTextModule,
    DialogModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    SpeedDialModule,
    PaginatorModule,
    BadgeModule,
    ListboxModule,
    CalendarModule,
    MultiSelectModule,
    ToastModule,
    ReceiptFooterComponent,
    InputNumberModule,
    TableModule,
    RadioButtonModule,
    AvatarModule
  ],
  exports: [
    CustomersSearchComponent,
    ItemsSearchComponent,
    ReceiptsPrintViewComponent,
    NewsDetailsReusableComponent,
    NewsListComponent,
    TransactionRecordAddComponent,
    PaymentIntegrationSetupComponent
  ]
})
export class EBMSuiteSharedModule {}
